<hfc-checkbox-list
  [isMulti]="true"
  [map]="map"
  [class.hf-invalid]="hfInvalid"
  [(ngModel)]="value"
  (ngModelChange)="onValueChange()"
></hfc-checkbox-list>
